(() => {
  if (window.lgsContactPopupLoaded) return;
  window.lgsContactPopupLoaded = true;

  function init(root = document) {
    root.querySelectorAll('form[data-lgs-contact]').forEach((form) => {
      if (form.dataset.lgsInitialized) return;
      const popup = document.getElementById(form.id.replace('ContactForm-', 'ContactPopup-'));
      if (!popup || typeof popup.showModal !== 'function') return;
      form.dataset.lgsInitialized = 'true';
      const errors = form.querySelector('[data-lgs-errors]');
      let busy = false;
      let previousFocus;
      let buttonState = 'idle';
      let verificationTimer;
      const submitButtons = [...form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]')];
      const labels = submitButtons.map(button => {
        if (button.tagName === 'INPUT') return { button, value: button.value };
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (node.textContent.trim() && !node.parentElement.closest('svg, [aria-hidden="true"], .icon')) {
            nodes.push({ node, text: node.textContent });
          }
        }
        return { button, nodes };
      });
      function setButtonState(state) {
        buttonState = state;
        const text = state === 'sending' ? 'Submitting…' : 'Submitted ✓';
        labels.forEach(label => {
          if ('value' in label) {
            label.button.value = state === 'idle' ? label.value : text;
          } else {
            label.nodes.forEach((item, index) => {
              item.node.textContent = state === 'idle' ? item.text : (index === 0 ? text : '');
            });
          }
        });
      }
      form.addEventListener('input', () => {
        if (!busy && buttonState === 'success') setButtonState('idle');
      });
      form.addEventListener('submit', () => {
        if (busy) return;
        setButtonState('sending');
        clearTimeout(verificationTimer);
        verificationTimer = setTimeout(() => {
          if (!busy && buttonState === 'sending') setButtonState('idle');
        }, 45000);
      }, true);
      function openPopup() {
        previousFocus = document.activeElement;
        if (!popup.open) popup.showModal();
      }
      popup.querySelector('[data-lgs-close]').addEventListener('click', () => popup.close());
      popup.addEventListener('click', (event) => {
        const rect = popup.getBoundingClientRect();
        if (event.target === popup && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) popup.close();
      });
      popup.addEventListener('close', () => previousFocus?.focus());
      function showError(message) {
        clearTimeout(verificationTimer);
        setButtonState('idle');
        errors.textContent = message;
        errors.hidden = false;
        errors.focus();
      }
      if (form.querySelector('[data-lgs-success]') && location.hash === '#' + form.id) {
        setButtonState('success');
        openPopup();
      }

      async function submitAjax() {
        if (busy) return;
        const captchaField = form.querySelector('[name="h-captcha-response"]');
        if ((window.Shopify?.captcha || captchaField) && !captchaField?.value) {
          showError('Verification is not ready. Please wait a moment and submit again.');
          return;
        }
        if (!form.reportValidity()) { setButtonState('idle'); return; }
        for (const group of form.querySelectorAll('[data-is-required]')) {
          if (!group.querySelector('input[type="checkbox"]:checked')) {
            showError('Please select at least one option in each required checkbox group.');
            return;
          }
        }
        errors.hidden = true;
        form.querySelectorAll('[data-lgs-server-errors]').forEach(el => { el.hidden = true; });
        const data = new FormData(form);
        const buttons = [...form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]')];
        const disabled = buttons.map(button => button.disabled);
        clearTimeout(verificationTimer);
        setButtonState('sending');
        busy = true;
        form.setAttribute('aria-busy', 'true');
        buttons.forEach(button => { button.disabled = true; });
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 30000);
        try {
          const response = await fetch(form.action, {
            method: 'POST', body: data, credentials: 'same-origin',
            headers: { Accept: 'text/html' }, signal: controller.signal
          });
          const finalURL = new URL(response.url, location.href);
          if (finalURL.origin === location.origin && /\/challenge\/?$/.test(finalURL.pathname)) {
            location.assign(finalURL.href);
            return;
          }
          if (!response.ok) throw new Error('server');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const returnedForm = html.getElementById(form.id);
          const serverErrors = returnedForm?.querySelector('[data-lgs-server-errors]');
          if (serverErrors) {
            showError(serverErrors.textContent.trim());
            return;
          }
          if (!returnedForm?.querySelector('[data-lgs-success]')) {
            showError('Submission could not be confirmed. Please check your connection before trying again.');
            return;
          }
          form.reset();
          setButtonState('success');
          openPopup();
        } catch (error) {
          showError('We could not confirm the submission. It may have been received. Please check before submitting again.');
        } finally {
          clearTimeout(timeout);
          busy = false;
          if (buttonState === 'sending') setButtonState('idle');
          form.removeAttribute('aria-busy');
          buttons.forEach((button, index) => { button.disabled = disabled[index]; });
        }
      }

      Object.defineProperty(form, 'submit', {
        configurable: true,
        writable: true,
        value: submitAjax
      });
      form.addEventListener('submit', (event) => {
        if (busy) { event.preventDefault(); return; }
        if (event.defaultPrevented) return;
        const token = form.querySelector('[name="h-captcha-response"]');
        if ((window.Shopify?.captcha || token) && !token?.value) return;
        event.preventDefault();
        queueMicrotask(() => { void submitAjax(); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
